import React from 'react';
import type { FC } from 'react';
import { Box, Text } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';
import type { BackOfficeExtensionContainer } from '@wix/extensions-data-client';
import type { ComponentGenerationResult } from '@wix/gena';
import { GenerationSuccessMessage } from '../../GenerationSuccessMessage.js';

const customGroupMessages = new Map([
  ['Checkout & Orders', 'generate_command.generation.ecommerce_notification'],
]);

export const DashboardMenuPluginGeneratedNote: FC<{
  backofficeMenuItem: BackOfficeExtensionContainer;
  generatedFiles: ComponentGenerationResult['newFiles'];
}> = ({ backofficeMenuItem, generatedFiles }) => {
  const { t } = useTranslation();

  const extensionType = t(
    'generate_command.flow.dashboard_menu_plugin'
  ).toLowerCase();

  const customKey = customGroupMessages.get(backofficeMenuItem.appName);

  return (
    <Box flexDirection="column">
      <GenerationSuccessMessage
        extensionType={extensionType}
        generatedFiles={generatedFiles}
        // https://dev.wix.com/docs/build-apps/developer-tools/cli/wix-cli-for-apps/extensions/dashboard-menu-plugin-extension-files-and-code
        learnMoreUrl="https://wix.to/YwaogfU"
      >
        {customKey ? <Text>{t(customKey)}</Text> : null}
      </GenerationSuccessMessage>
    </Box>
  );
};
